import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { LoanDetailsHistoryObj } from "../../utils/types";

const initialState: LoanDetailsHistoryObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getLoanHistoryData = createAsyncThunk(
  "loans/getLoanDetailsHistory",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const loanDetailsHistorySlice = createSlice({
  name: "loans",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLoanHistoryData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLoanHistoryData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload?.data;
      })
      .addCase(getLoanHistoryData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default loanDetailsHistorySlice.reducer;
